import React, { useContext, useState } from "react";
import {
    Container,
    CloseDiv,
    HeaderDiv,
    CloseImg,
    GridContainer,
    HeaderText,
    Input,
    InputDiv,
    InputLabel,
    OptionsDiv,
    ButtonOfSection,
    ButtonOfSectionText,
    PlusImg
} from './style'
import cross from '../../../../assets/orders/cross.svg'
import plus from '../../../../assets/headers/plus.svg'
import save from '../../../../assets/router/save.svg'
import pen  from '../../../../assets/edit-pen-white.svg'
import {elements} from './utils'
import ModalContext from "../../../../contexts/ModalContext";
import { VehicleContext } from "../../../../contexts/VehicleContext";
import axios from "axios";
import { id } from "date-fns/locale";
import { ButtonCreate } from "../../style";
import { FeedbackContext } from "../../../../contexts/FeedbackContext";
import { useNavigate, useOutletContext } from "react-router-dom";
import { EquipmentOutletType } from "../../../../pages/ClientPanel/Equipment";
import ModalTest from "../../../BaseModal";

export interface VehicleInterface {
    id: number,
    plate: string,
    model: string,
    year: number,
    capacity: number,
    size: number,
    restriction: string
}

const VehicleForm = ()=>{
    const {setModalActive, setModalSection} = useContext(ModalContext)
    const {vehicle, setVehicle} = useContext(VehicleContext)
    const { setFeedback } = useContext(FeedbackContext)
    
    const [formData, setFormData] = useState(
        {
            id: vehicle?.id || 0,
            plate: vehicle?.plate || '',
            model: vehicle?.model || '',
            year: vehicle?.year || '',
            capacity: vehicle?.capacity || '',
            size: vehicle?.size || '',
            restriction: vehicle?.restriction || ''
        }
    )

    const navigate = useNavigate()

    const handleDataChange = (field: string,value: any)=>{
        
        setFormData((prevData)=>({
            ...prevData,
            [field]: value
        }))

    }

    const close = ()=>{
       
        
        setVehicle(null)
        navigate('..')
    }


    const saveVehicle = async (vehicle: any)=>{
        const body = {
            plate: formData.plate,
            model: formData.model,
            year:  Number(formData.year),
            capacity: Number(formData.capacity),
            size: Number(formData.size),
            restriction: formData.restriction
        }
        try{

                    const  response = await axios.post(`${process.env.REACT_APP_ROUTER_BASE_URL}/vehicle`, body)
                    if(response){
                        setFeedback({
                            isOpen:true,
                            message:'Veículo cadastrado com sucesso',
                            statusOk:true
                          })
                           
                          close()
                    }
                  
        }catch(err){
            console.log(err)
            setFeedback({
                isOpen:true,
                message:'Erro ao cadastrar Veículo',
                statusOk:false
              })
        }
    }

    const vehicleValidator = (body: any)=>{
        if(body.plate === ''){
            return false
        }
        return true
    }
    const updateVehicle = async (vehicle: any)=>{
        const body = {
            plate: formData.plate,
            model: formData.model,
            year:  Number(formData.year),
            capacity: Number(formData.capacity),
            size: Number(formData.size),
            restriction: formData.restriction
            
        }
        try{
            if(vehicleValidator(body)){
                const  response = await axios.put(`${process.env.REACT_APP_ROUTER_BASE_URL}/vehicle/${vehicle.id}`, body)
                if(response){
                    setFeedback({
                        isOpen:true,
                        message:'Veículo atualizado com sucesso',
                        statusOk:true
                      })
                }
               
                close()
                return
            }
            setFeedback({
                isOpen:true,
                message:'Erro ao atualizar o veículo',
                statusOk:false
              })
                    
        }catch(err){
            console.log(err)
        }
    }
    return(
        <ModalTest>
        <Container>
               

        <GridContainer>
    <HeaderDiv style={{gridArea: `titleNew`}}>
                <HeaderText>{vehicle ? `Editar Veículo:  ${vehicle.plate}` : "Novo Veículo"}</HeaderText>
                <CloseDiv onClick={() => close()} >
                    <CloseImg src={cross} alt='Close tab' />
                </CloseDiv>
            </HeaderDiv>
                {
                    elements.map((element, index)=>(
                        <>
                        <InputDiv style={{ gridArea: element.gridArea }}>
                        <InputLabel>{element.inputLabel}</InputLabel>
                        <Input value={formData[element.field]}  type={element.type} onChange={(e)=>handleDataChange(element.field, e.target.value)} placeholder="Digite aqui"> 
                        </Input>
                        </InputDiv>
                        </>
                    ))
                }
                </GridContainer>
                <OptionsDiv>
                    <ButtonCreate onClick={()=>close()} className="reverse">Cancelar</ButtonCreate>

                    <ButtonCreate onClick={()=>vehicle ? updateVehicle(vehicle) : saveVehicle(formData)}>
                        <PlusImg src={ vehicle ? save:plus}></PlusImg>
                        { vehicle ? "Salvar alterações": "Salvar veículo"}
                    </ButtonCreate>
                </OptionsDiv>
        </Container>
        </ModalTest>
    )
}

export default VehicleForm